import { EmployerForm } from "./EmployerForm";

export const EmployerCTA = () => {
  return (
    <section className="qh-cta-band" id="start-hiring">
      <div className="qh-wrap">

        <div className="qh-cta-band-inner">

          <div className="qh-cta-copy">

            <span className="qh-tag">
              // Send us a req
            </span>

            <h2>
              Tell us about the role.
              <br />
              A recruiter picks it up the same day.
            </h2>

            <p>
              Submit a req through the platform and a recruiter picks it
              up the same day — backed by a 5M-profile AI engine working
              your role from the moment it lands.
            </p>

            <ul className="qh-cta-points">
              <li>
                Shortlist in hours, not after a week of searching
              </li>

              <li>
                AI-ranked candidates, reviewed by a real recruiter
              </li>

              <li>
                Results-based pricing, not a seat license
              </li>
            </ul>

          </div>

          <div className="qh-cta-form-card">
            <EmployerForm />
          </div>

        </div>

      </div>
    </section>
  );
};
